export default __webpack_public_path__ + "static/media/billing.d38bfaa9.svg";